<script>
import moment from 'moment';

const getBadgeClass = function (queue, days) {
    if (days >= queue.activity_status_forgotten_days) {
        return 'badge-dark';
    }

    if (days >= queue.activity_status_critical_days) {
        return 'badge-critical';
    }

    if (days >= queue.activity_status_late_days) {
        return 'badge-late';
    }

    if (days >= queue.activity_status_hurry_days) {
        return 'badge-warning';
    }

    return 'badge-success';
};

export default {
    name: 'DaysActivityStatusBadge',

    functional: true,

    props: {
        date: {
            type: String,
            default: () => moment(new Date).format('YYYY-MM-DD'),
            validator: (value) => {
                if (!value || value.length === 0) {
                    return true;
                }

                return moment(value).isValid();
            },
        },
        queue: {type: Object, required: true},
        none: {type: String, default: null},
        title: {type: String, default: null},
        append: {type: String, default: null},
    },

    render(createElement, {props, data, parent}) {
        const pastDate = moment(props.date).format('YYYY-MM-DD');
        const currentDate = moment(new Date).format('YYYY-MM-DD');
        const days = moment(currentDate).diff(pastDate, 'days');

        const badgeClass = getBadgeClass(props.queue, days);
        const badgeText = parent.$tc('common.days.count-today', days);
        const badgeTtitle = props.title || parent.$t('queues.fields.activity_status_days.title');

        return createElement(
            'span',
            {
                ...data,
                class: ['badge', badgeClass, data.staticClass, data.class],
                attrs: {
                    ...data.attrs,
                    title: badgeTtitle,
                },
                directives: [{name: 'tooltip'}],
            },
            [badgeText, props.append ? ` ${props.append}` : null],
        );
    },
};
</script>
